<div class="app-container">
  @if (showHeaderSignal) {
    <app-header />
  }

  <div class="app-shell" [class.app-shell--with-nav]="showMainNavigation()">
    @if (showMainNavigation()) {
      <app-main-navigation />
    }

    <main class="main-content">
      <router-outlet />
    </main>
  </div>

  <app-notification-container />
</div>
